/* eslint-disable */

import React from "react";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { fetchGraphQL } from "../../../services/api-raindrop";
import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";

import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropCircle from "../../../ui-components/raindrop-circle/raindrop-circle.tsx";

import RaindropCarousel from "../../../ui-components/raindrop-carousel/raindrop-carousel";
import TagElementMotion from "../../../ui-components/tag-element-motion/tag-element-motion.tsx";
import OrganisationActivityElement from "../../../ui-components/organisation-activity-element/organisation-activity-element.tsx";
import RaindropMotionFadeUp from "../../../ui-components/raindrop-motion-fade-up/raindrop-motion-fade-up.tsx";
import OrganisationLogo from "../../../ui-components/organisation-logo/organisation-logo.js";
import OrganisationTitle from "../../../ui-components/organisation-title/organisation-title.tsx";
import SupportButton from "../../../ui-components/organisation-support-button/organisation-support-button.js";
import RaindropCard, {
  RaindropCardStyle,
} from "../../../ui-components/raindrop-card/raindrop-card.tsx";
import RaindropHeading from "../../../ui-components/raindrop-heading/raindrop-heading.tsx";

import { Size } from "../../../logic/enums.ts";
import RaindropTextParagraph from "../../../ui-components/raindrop-text-paragraph/raindrop-text-paragraph.tsx";
import RaindropTextHeading1 from "../../../ui-components/raindrop-text-heading-1/raindrop-text-heading-1.tsx";
import RaindropTextSubtitle from "../../../ui-components/raindrop-text-subtitle/raindrop-text-subtitle.tsx";

import ContributionSlider from "../../../ui-components/contribution-slider/contribution-slider.tsx";
import RaindropBackButtonPanel from "../../../ui-components/raindrop-back-button-panel/raindrop-back-button-panel.tsx";
import RaindropClickable from "../../../ui-components/raindrop-clickable/raindrop-clickable.tsx";
import PoliticalChart from "../../../ui-components/political-chart/political-chart.tsx";

import RaindropCardWarning from "../../../ui-components/raindrop-card-warning/raindrop-card-warning.tsx";
import FlexRow from "../../../ui-components/flex-row/flex-row.tsx";
import Spacer from "../../../ui-components/spacer/spacer.js";

import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";
import OrganisationListElement from "../../../ui-components/organisation-list-element/organisation-list-element.tsx";
import { EXAMPLE_ORGANISATION_ALPHA_URL } from "../../../services/constants.js";
import { isProductionEnvironment } from "../../../services/environment.js";

const VolunteeringTag = ({ volunteeringTag }) => {
  let displayText = "Unknown";
  let iconClass = "fa fa-hand-fist";

  switch (volunteeringTag) {
    case "VOLUNTEERING_TAG_PROTEST":
      displayText = "Protest";
      iconClass = "fa fa-hand-fist";
      break;
    case "VOLUNTEERING_TAG_PLANTING":
      displayText = "Planting";
      iconClass = "fa fa-seedling";

    default:
      break;
  }
  return (
    <FlexRow className="w-full">
      <FlexRow
        className=" w-fit max-w-fit text-sm font-bold text-color-dark-text-secondary"
        tailwindGap="gap-1"
      >
        <i className={iconClass} />
        {displayText}
      </FlexRow>
    </FlexRow>
  );
};
const StarRating = ({ value = 4 }) => {
  return (
    <FlexRow>
      <i className="fa fa-star" />
      <i className="fa fa-star" />
      <i className="fa fa-star" />
      <i className="fa fa-star" />
      <i className="fa fa-star opacity-20" />
    </FlexRow>
  );
};

const VolunteeringEvent = ({ title, volunteeringTag }) => {
  const navigate = useNavigate();
  return (
    <RaindropClickable
      additionalClasses="w-full max-w-[250px]"
      onClick={() => navigate("/raindrop/volunteer/instance")}
    >
      <RaindropCard>
        <FlexCol>
          <div className="flex flex-col w-full relative">
            <div className="bg-red-400 w-full aspect-square rounded-lg " />

            <div className="absolute p-2">
              <OrganisationLogo
                src={EXAMPLE_ORGANISATION_ALPHA_URL}
                isSmall={true}
              />
            </div>
          </div>
          <RaindropTextHeading1 className="w-full">
            {title}
          </RaindropTextHeading1>

          <RaindropTextSubtitle className="w-full">
            1.5 hours
          </RaindropTextSubtitle>

          <StarRating />
          <VolunteeringTag volunteeringTag={volunteeringTag} />
        </FlexCol>
      </RaindropCard>
    </RaindropClickable>
  );
};

const RaindropVolunteer = ({}) => {
  if (isProductionEnvironment()) {
    return null;
  }
  const volunteeringEventObjects = [
    {
      title: "Protest Big Oil Drilling",
      volunteeringTag: "VOLUNTEERING_TAG_PROTEST",
    },
    {
      title: "Cabbage harvesting",
      volunteeringTag: "VOLUNTEERING_TAG_PLANTING",
    },
    {
      title: "Tree planting at Redwood beach",
      volunteeringTag: "VOLUNTEERING_TAG_PLANTING",
    },
    {
      title: "Cabbage harvesting",
      volunteeringTag: "VOLUNTEERING_TAG_PLANTING",
    },
    {
      title: "Tree planting at Redwood beach",
      volunteeringTag: "VOLUNTEERING_TAG_PLANTING",
    },
  ];

  return (
    <RaindropPage>
      Volunteering page
      <FlexRow className="flex-wrap">
        {volunteeringEventObjects.map((volunteeringEvent) => (
          <VolunteeringEvent
            title={volunteeringEvent.title}
            volunteeringTag={volunteeringEvent.volunteeringTag}
          />
        ))}
      </FlexRow>
    </RaindropPage>
  );
};

export default RaindropVolunteer;
